// extracted by mini-css-extract-plugin
export default {"strip":"p13keb","viewArea":"ZIDxfg"};